<mat-dialog-content>
    <h1 class="title">Cancer Experience Registry</h1>
    <div class="item">
        <h4>Choose an hospital:</h4>
        <select class="custom-select" [(ngModel)]="hospitalId">
            <option id="select-hospital" *ngFor="let h of hospitals" [ngValue]="h">{{ data.hospitals[h] }}</option>
        </select>
    </div>
</mat-dialog-content>
<mat-dialog-actions id="login-button">
    <button class="btn button turquoise button-login" (click)="login()">Login</button>
</mat-dialog-actions>
